"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectValues = (obj) => Object.values(obj);
exports.objectKeys = (obj) => Object.keys(obj);
exports.formatUsername = (username) => {
    return String(username !== null && username !== void 0 ? username : '')
        .replace(/\s/, '')
        .toLowerCase();
};
